import { useSnackbar } from 'notistack';
import { useApi } from '../../../shared/context';
import { TermSheetFacility } from '../../../shared/models';
import { useMutation } from 'react-query';
import { getApiResponseData } from '../../../shared/utils/axios';
import { CerebroApiEndpoints } from '../../../shared/utils/api';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { CerebroTextButton } from '../../../shared/components';

interface PainPointConfirmationDialogProps {
	dataRoomGuid: string | undefined;
	termSheetGuid: string | undefined;
	revisionGuid: string | undefined;
	facility: TermSheetFacility | null;
	close: () => void;
}

export const PainPointConfirmationDialog: React.FC<PainPointConfirmationDialogProps> = ({
	dataRoomGuid,
	termSheetGuid,
	revisionGuid,
	facility,
	close,
}) => {
	const api = useApi();
	const snackbar = useSnackbar();

	const onCreateConfirmation = () => {
		if (facility !== null) createPainPoint(facility);
	};

	const { mutate: createPainPoint } = useMutation<string, unknown, TermSheetFacility>(
		async facilityToCreate => {
			const { data, error } = await getApiResponseData<string>(
				api.post(
					CerebroApiEndpoints.TermSheets.PainPoint(
						dataRoomGuid,
						termSheetGuid,
						revisionGuid,
						facilityToCreate?.guid
					)
				)
			);

			if (error) {
				throw new Error(error.response?.data);
			}
			if (data === null || data === undefined) {
				throw new Error('No data returned from API');
			}

			return data;
		},
		{
			onMutate: () => {
				close();
			},
			onSuccess: (data: string) => {
				window.location.href = data;
				close();
			},
			onError: () => {
				snackbar.enqueueSnackbar('There was a problem deleting the facility.', { variant: 'error' });
			},
		}
	);

	return (
		<Dialog open={facility !== null} onClose={close}>
			<DialogTitle>Confirm Creation of Deal Sonar Opportunity</DialogTitle>
			<DialogContent>
				<DialogContentText>
					Do you want to create a Deal Sonar opportunity for this facility? You will be forwarded to the loan
					watch page to add details prior to activating it for lenders.
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<CerebroTextButton onClick={close}>No</CerebroTextButton>
				<CerebroTextButton onClick={onCreateConfirmation}>Yes</CerebroTextButton>
			</DialogActions>
		</Dialog>
	);
};
